const $ = require('jquery');

export default {
  init() {
    const state = {
      mobile: true
    };
    const container = document.querySelector('.iln__body-inner');
    const items = document.querySelectorAll('.iln__frame');

    const calculateWidth = () => {
      if (container && items) {
        const itemWidth = (items[0] as HTMLElement).offsetWidth;
        $(container).width(itemWidth * items.length + 80);
      }
    };

    $(window).resize(() => {
      if ($(window).width() < 768) {
        state.mobile = true;
        calculateWidth();
      } else {
        state.mobile = false;
        $(container).removeAttr('style');
      }
    });

    if ($(window).width() < 768) {
      state.mobile = true;
      calculateWidth();
    } else {
      state.mobile = false;
      $(container).removeAttr('style');
    }
  }
};
